import { Box, Container, Typography, Link, Stack } from "@mui/material";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";

const LINKS = [
  { label: 'Features', id: 'features' },
  { label: 'Workflow', id: 'workflow' },
  { label: 'Benefits', id: 'benefits' },
  { label: 'FAQ', id: 'faq' },
  { label: 'Contact Us', id: 'contact' },
];

function Footer() {
  const handleScroll = (id) => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        overflow: "hidden",

        background:
          "linear-gradient(180deg, #f8fafc 0%, #e0f2fe 50%, #f8fafc 100%)",

        borderTop: "1px solid rgba(226,232,240,0.9)",
        pt: { xs: 5, md: 6 },
        pb: 4,
      }}
    >
      <Container maxWidth="lg">

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: 3,
          }}
        >
          {/* EMAIL */}
          <Box>
            <Stack direction="row" spacing={1} sx={{ alignItems: "center", mt: 1.5 }}>
              <EmailRoundedIcon sx={{ fontSize: 17, color: "text.secondary" }} />

              <Link
                href="mailto:sales@ytctechventures.com"
                variant="body2"
                underline="hover"
                sx={{ color: "text.secondary" }}
              >
                sales@ytctechventures.com
              </Link>
            </Stack>
          </Box>

          <Stack direction="row" spacing={3} useFlexGap sx={{ flexWrap: "wrap" }}>
            {LINKS.map((link) => (
              <Typography
                key={link.id}
                onClick={() => handleScroll(link.id)}
                sx={{
                  cursor: "pointer",
                  color: "text.secondary",
                  fontSize: "0.875rem",
                  "&:hover": {
                    color: "text.primary",
                  },
                }}
              >
                {link.label}
              </Typography>
            ))}
          </Stack>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            mt: 4,
            pt: 3,
            borderTop: "1px solid rgba(226,232,240,0.9)",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            © {new Date().getFullYear()} FlowSync. All rights reserved.
          </Typography>

          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Powered by{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(120deg, #4f6bed, #16b8a6)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              YTCTechventures
            </Box>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;